<template>
  <div>
    <b-button
      id="id-assign-convo-btn"
      type="button"
      pill
      variant="outline-info"
      class="btn btn-rounded btn-block btn-light"
      :disabled="httpPending"
      @click.prevent="openTransferConversationModal()"
    >
      <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
      Transfer Conversation
    </b-button>
  </div>
</template>

<script>
import { EventBus } from "@/events/eventBus";
import TransferConversationForm from "@/components/conversations/TransferConversationForm";

export default {
  props: {
    conversationId: String,
    sessionId: String
  },
  data() {
    return {
      httpPending: false,
    };
  },
  methods: {
    openTransferConversationModal() {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: TransferConversationForm,
        title: "Transfer Conversation",
        closeOnClick: true,
        props: {
          conversationId: this.conversationId,
          sessionId: this.sessionId
        }
      });
    }
  }
};
</script>
